<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="data.id!='Sirket'?10:10">
        <Kasalar :data="data" @KasaBakiye="KasaBakiye($event)" :Bina_id="data.id"></Kasalar>
      </el-col>
      <el-col :span="data.id!='Sirket'?14:14">
        <el-row :gutter="24">
          <el-col v-if="widget" v-for="w in widget" :span="w.col" :style="w.style" style="padding: 0">
            <mWidget class="mb-2" :data="w"></mWidget>
          </el-col>
          <el-col :span="24">
            <el-tabs type="border-card" class="tabs-center tab-p0">
              <el-tab-pane v-if="data.id!='Sirket'" label="Güncel Alacak" :lazy=true>
                <Tahakkuklar :Bina_id="data.id"></Tahakkuklar>
              </el-tab-pane>
              <el-tab-pane v-if="data.id!='Sirket'" label="Güncel Borç" :lazy=true>
                <Borclar :Bina_id="data.id"></Borclar>
              </el-tab-pane>
              <el-tab-pane v-if="data.id!='Sirket'" label="İcralar" :lazy=true>
                <BinaIcra :Bina_id="data.id"></BinaIcra>
              </el-tab-pane>
              <el-tab-pane label="Alacak Özet" :lazy=true>
                <Alacak :Bina_id="data.id"></Alacak>
              </el-tab-pane>
              <el-tab-pane label="Cari Özet" :lazy=true>
                <Cari :Bina_id="data.id"></Cari>
              </el-tab-pane>
              <el-tab-pane v-if="data.id!='Sirket'" label="Emanet Özet" :lazy=true>
                <Emanet :Bina_id="data.id"></Emanet>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Kasalar from "./Detay/Kasalar";
import MWidget from "../../../Genel/mWidget";
import Tahakkuklar from "./Detay/Tahakkuklar";
import Borclar from "./Detay/Borclar";
import BinaIcra from "./Detay/BinaIcra";
import Alacak from "./Detay/Alacak";
import Cari from "./Detay/Cari";
import Emanet from "./Detay/Emanet";

export default {
  props: ['data'],
  components: {Emanet, Cari, Alacak, BinaIcra, Borclar, Tahakkuklar, MWidget, Kasalar},
  data() {
    return {
      KasaBilgi: {
        Bakiye: 0,
        Gelir: 0,
        Gider: 0
      },
      BorcBilgi: 0,
      AlacakBilgi: 0,
      GuncelAktif: 'alacak',
      widget: null,
    }
  },
  methods: {
    Ozet(veri) {
      this.AlacakBilgi = veri.Alacak;
      this.BorcBilgi = veri.Borc;

      //if ($store.getters.Paket === 1) this.widgetGuncelle();
      //if ($store.getters.Paket === 2) this.awidgetGuncelle();
    },
    KasaBakiye(veri) {
      this.KasaBilgi = veri;
      //this.widgetGuncelle();
      if (this.$store.getters.Paket == 1) this.widgetGuncelle();
      if (this.$store.getters.Paket == 2) this.awidgetGuncelle();
    },
    widgetGuncelle() {
      this.widget = [
        {
          isim: 'Kasa Bakiye',
          sayi: this.KasaBilgi.Bakiye,
          icon: 'feather-check-circle',
          renk: 'border-0 ins1',
          col: 6,
          style: 'padding-left:12px'
        },
        {
          isim: 'Bloke',
          sayi: this.KasaBilgi.Bloke,
          icon: 'feather-clock',
          renk: 'border-0 ins2',
          col: 4,
          style: ''
        },
        // {
        //   isim: 'Zam Geliri',
        //   sayi: this.KasaBilgi.ZamGelir,
        //   icon: 'el-icon-plus',
        //   renk: 'border-0 ins5',
        //   col: 4,
        //   style: ''
        // },
        {
          isim: 'Gelir <small>[ Virman: ' + this.KasaBilgi.Virman + ']</small>',
          sayi: this.KasaBilgi.Gelir,
          icon: 'feather-arrow-down-circle',
          renk: 'border-0 ins3',
          col: 7,
          style: ''
        },
        {
          isim: 'Gider <small>[ Virman: ' + this.KasaBilgi.Virman + ']</small>',
          sayi: this.KasaBilgi.Gider,
          icon: 'feather-arrow-up-circle',
          renk: 'border-0 ins4',
          col: 7,
          style: 'padding-right:12px'
        },

        /*{isim: 'Alacak', sayi: this.AlacakBilgi + ' TL', icon: 'el-icon-plus', renk: 'ins5'},
        {isim: 'Borç', sayi: this.BorcBilgi + ' TL', icon: 'el-icon-minus', renk: 'ins6'},*/
      ]
    },
    awidgetGuncelle() {
      this.widget = [
        {
          isim: 'Kasa Bakiye',
          sayi: this.KasaBilgi.Bakiye,
          icon: 'el-icon-check',
          renk: 'border-0 ins1',
          col: 6,
          style: 'padding-left:12px'
        },
        {
          isim: 'Bloke',
          sayi: this.KasaBilgi.Bloke,
          icon: 'el-icon-close',
          renk: 'border-0 ins2',
          col: 6,
          style: ''
        },
        {
          isim: 'Gelir <small>[ Virman: ' + this.KasaBilgi.Virman + ']</small>',
          sayi: this.KasaBilgi.Gelir,
          icon: 'el-icon-arrow-down',
          renk: 'border-0 ins3',
          col: 6,
          style: ''
        },
        {
          isim: 'Gider <small>[ Virman: ' + this.KasaBilgi.Virman + ']</small>',
          sayi: this.KasaBilgi.Gider,
          icon: 'el-icon-arrow-up',
          renk: 'border-0 ins4',
          col: 6,
          style: 'padding-right:12px'
        },

        /*{isim: 'Alacak', sayi: this.AlacakBilgi + ' TL', icon: 'el-icon-plus', renk: 'ins5'},
        {isim: 'Borç', sayi: this.BorcBilgi + ' TL', icon: 'el-icon-minus', renk: 'ins6'},*/
      ]
    },
    SayfaYukle() {
      /*
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.data.id + '/ozet'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Ozet(response);
          }
        });

       */
    }
  },
  created() {
    this.SayfaYukle();
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/BinaOzetEkran.vue